export default "__VITE_ASSET__vNURvfLr__"